import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35c332db"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page page-alerts-history page-table" }
const _hoisted_2 = { class: "page-table-body" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "alert-information" }
const _hoisted_5 = { class: "table-main hide-sp" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "市区町村"),
    /*#__PURE__*/_createElementVNode("th", null, "発表中")
  ])
], -1))
const _hoisted_7 = { class: "city" }
const _hoisted_8 = { class: "alerts" }
const _hoisted_9 = { class: "sp-table-main hide-pc" }
const _hoisted_10 = { class: "city" }
const _hoisted_11 = { class: "alerts" }
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<h4 class=\"legends-sp-title hide-pc\" data-v-35c332db>凡例</h4><ul class=\"legends flex mt-2 bc-2\" data-v-35c332db><li class=\"legend legend-heading hide-sp\" data-v-35c332db>凡例</li><li class=\"legend legend-item\" data-v-35c332db><span class=\"legend-swatch level-5\" data-v-35c332db></span><span class=\"legend-label\" data-v-35c332db>レベル5特別警報、特別警報</span></li><li class=\"legend legend-item\" data-v-35c332db><span class=\"legend-swatch level-4\" data-v-35c332db></span><span class=\"legend-label\" data-v-35c332db>レベル4危険警報</span></li><li class=\"legend legend-item\" data-v-35c332db><span class=\"legend-swatch level-3\" data-v-35c332db></span><span class=\"legend-label\" data-v-35c332db>レベル3警報、警報</span></li><li class=\"legend legend-item\" data-v-35c332db><span class=\"legend-swatch level-2\" data-v-35c332db></span><span class=\"legend-label\" data-v-35c332db>レベル2注意報、注意報</span></li></ul>", 2)

import { computed, onMounted } from 'vue'
import moment from 'moment'
import { ALERT_KIND_STATUSES, ALERT_KIND_CANCEL_CODE } from '@/models/WeatherWarning'
import { AlertKind2, River } from '@/models/WeatherWarning2'
import { resolveAlertLevel } from '@/models/weatherWarningCode'
import SpAlertsLinks from '@/components/alerts/SpAlertsLinks.vue'
import { useWeatherWaringStore } from '@/stores/weatherWarningStore'
import { useInitDataStore } from '@/stores/initDataStore'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const CONDITION_CLASSES = {
  [ALERT_KIND_STATUSES.NEW]: 'new',
  [ALERT_KIND_STATUSES.CANCEL]: 'cancel',
  [ALERT_KIND_STATUSES.CONTINUE]: 'continue',
  [ALERT_KIND_STATUSES.CANCEL_SPECIAL]: 'cancel-special',
  [ALERT_KIND_STATUSES.CANCEL_ALERT]: 'cancel-alert',
}

const initDataStore = useInitDataStore()
const weatherWarningSotre = useWeatherWaringStore()

onMounted(() => {
  const areaList = initDataStore.initData.definitionInfo.alerts?.common?.areaInfo || []

  weatherWarningSotre.fetch(areaList)
})

const data = computed(() => {
  return {
    weatherWarningData: weatherWarningSotre.weatherWarningData,
  }
})

// 警戒レベル（2〜5）に応じた背景色クラスを返す（範囲外は色なし）
const levelClass = (level: number) => {
  return level >= 2 && level <= 5 ? `level-${level}` : ''
}

// code から辞書を参照して警戒レベルを判定し、背景色クラスを決定する
const codeLevelClass = (code?: string) => {
  return levelClass(resolveAlertLevel(code))
}

const kindClass = (kind: AlertKind2) => {
  const conditionClass = CONDITION_CLASSES[kind.status]

  return [conditionClass, codeLevelClass(kind.code)]
}

const kindLabel = (kind: AlertKind2) => {
  return kind.rawName || kind.name
}

const riverClass = (river: River) => {
  return codeLevelClass(river.kindCode)
}

const riverLabel = (river: River) => {
  return `${river.kindName}（${river.name}）`
}

// 解除コード（ALERT_KIND_CANCEL_CODE）以外（発表中）を表示する
const filterNotCancelKinds = (kinds: AlertKind2[]) => {
  // [2026/07/01] 飛んできているapiの解除codeが00ではなく、警報のcodeが飛んできていた為、一時的にstatusで判定するように変更
  // return kinds.filter(kind => kind.code !== ALERT_KIND_CANCEL_CODE)
  return kinds.filter(kind => kind.status !== ALERT_KIND_STATUSES.CANCEL)
}

const alertInformation = computed(() => {
  const warningData = data.value.weatherWarningData

  if (warningData.length === 0) {
    return ''
  }

  const { updatedAt, publishingOffice } = warningData[0]
  const dateLabel = moment(updatedAt).format('YYYY年MM月DD日 HH時mm分')

  return `${dateLabel} ${publishingOffice}発表`
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SpAlertsLinks),
    _createElementVNode("div", _hoisted_2, [
      (_unref(data).weatherWarningData.length === 0)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, "警報は発表されていません。"))
        : _createCommentVNode("", true),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(alertInformation)), 1),
      _createElementVNode("table", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).weatherWarningData, (datum, index) => {
            return (_openBlock(), _createElementBlock("tr", { key: index }, [
              _createElementVNode("td", _hoisted_7, _toDisplayString(datum.area.name), 1),
              _createElementVNode("td", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filterNotCancelKinds(datum.kinds), (kind, kindIndex) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: kindIndex,
                    class: _normalizeClass([kindClass(kind), "alert-item"])
                  }, _toDisplayString(kindLabel(kind)), 3))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datum.rivers, (river, riverIndex) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: `river-${riverIndex}`,
                    class: _normalizeClass([riverClass(river), "alert-item"])
                  }, _toDisplayString(riverLabel(river)), 3))
                }), 128))
              ])
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).weatherWarningData, (datum, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "area-box"
          }, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(datum.area.name), 1),
            _createElementVNode("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filterNotCancelKinds(datum.kinds), (kind, kindIndex) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: kindIndex,
                  class: _normalizeClass([kindClass(kind), "alert-item"])
                }, _toDisplayString(kindLabel(kind)), 3))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datum.rivers, (river, riverIndex) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: `river-${riverIndex}`,
                  class: _normalizeClass([riverClass(river), "alert-item"])
                }, _toDisplayString(riverLabel(river)), 3))
              }), 128))
            ])
          ]))
        }), 128))
      ]),
      _hoisted_12
    ])
  ]))
}
}

})